import { ALL_PERMISSIONS } from 'consts/permissions';
import { createSelector } from 'reselect';
import { NAME } from './user.consts';

export const userSelector = state => state[NAME];
export const selectDefaultCampaignMargin = state =>
  state.user.campaignMargin.defaultValue;

export const selectUserPermissions = createSelector(
  state => state[NAME],
  user => ALL_PERMISSIONS.filter(permission => user[permission] === true) || [],
);

export const isUserLoggedIn = createSelector(
  state => state[NAME],
  user => user.isLoggedIn === true,
);

export const selectUserBuyer = createSelector(
  state => state[NAME],
  user => user.buyer,
);

export const selectUserPublisher = createSelector(
  state => state[NAME],
  user => user.publisher,
);

export const isUserBuyer = createSelector(
  state => state[NAME],
  user => typeof user.buyer?.id === 'number',
);

export const selectUserEmail = createSelector(
  state => state[NAME],
  user => user.email,
);

export const selectUserSide = createSelector(
  state => state[NAME],
  user => (typeof user.buyer?.id === 'number' ? 'buyer' : 'publisher'),
);

export const selectUserData = createSelector(
  state => state[NAME],
  user => user,
);

export const selectIfUserCanSetExtraFees = createSelector(
  state => state[NAME],
  user => user.publisher?.monthlyExtraFeeEnabled,
);

export const selectIfPublisherCanSetCustomProductGroups = createSelector(
  state => state[NAME],
  user => user.publisher?.accessPerProductGroupEnabled,
);

export const selectUserId = createSelector(
  state => state[NAME],
  user => user.id,
);

export const selectUserCampaignTablePreferences = createSelector(
  state => state[NAME],
  user => {
    if (!user?.preferences) return null;
    return user?.preferences?.TableCampaignPreferences || {};
  },
);

export const selectUserProposalTablePreferences = createSelector(
  state => state[NAME],
  user => {
    if (!user?.preferences) return null;
    return user?.preferences?.TableProposalPreferences || {};
  },
);

export const selectUserProductTablePreferences = createSelector(
  state => state[NAME],
  user => {
    if (!user?.preferences) return null;
    return user?.preferences?.TableProductPreferences || {};
  },
);

export const selectUserUserTablePreferences = createSelector(
  state => state[NAME],
  user => {
    if (!user?.preferences) return null;
    return user?.preferences?.TableUserPreferences || {};
  },
);

export const selectUserDashboardTablePreferences = createSelector(
  state => state[NAME],
  user => {
    if (!user?.preferences) return null;
    return user?.preferences?.TableDashboardPreferences || {};
  },
);

export const selectUserDialogsPreferences = createSelector(
  state => state[NAME],
  user => {
    if (!user?.preferences) return null;
    return user?.preferences?.Dialogs || {};
  },
);
